<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Log center</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Logger</li>
        </ol>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12 logsForm">
      <mat-card>
        <form [formGroup]="logsForm" onsubmit="return false">
          <mat-form-field appearance="fill">
            <mat-label>Modules</mat-label>
            <mat-select
              disableOptionCentering
              #modulesSelect
              formControlName="module"
              multiple
            >
              <mat-select-trigger>
                {{ module.value ? module.value[0] : '' }}
                <span *ngIf="module.value?.length > 1">
                  (+{{ module.value.length - 1 }}
                  {{ module.value?.length === 2 ? 'other' : 'others' }})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let module of modules" [value]="module.value">
                {{ module.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="module.hasError('required')"
              >You must make a selection</mat-error
            >
          </mat-form-field>

          <!-- TODO - pas eu le temps
                        <mat-form-field appearance="fill">
                        <mat-label>Log Bundles</mat-label>
                        <mat-select
                            disableOptionCentering
                            #bundlesSelect
                            [formControl]="bundlesForm">
                            <mat-option *ngFor="let bundle of bundles" [value]="bundle">
                            {{ bundle }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->

          <mat-form-field appearance="fill">
            <mat-label>Types</mat-label>
            <mat-select
              disableOptionCentering
              #typesSelect
              formControlName="type"
              multiple
            >
              <mat-option *ngFor="let type of types" [value]="type">
                {{ type }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Date Range (Max 7 days)</mat-label>
            <mat-date-range-input
              [rangePicker]="picker"
              [formGroup]="dateRange"
              [max]="maxDate"
            >
              <input
                matStartDate
                formControlName="dateStart"
                placeholder="Start Date"
              />
              <input
                matEndDate
                formControlName="dateEnd"
                placeholder="End Date"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Organisations</mat-label>
            <mat-select [formControl]="organisation">
              <mat-option value="ALL">ALL</mat-option>
              <mat-option *ngFor="let org of organisations" [value]="org.tag">{{
                org.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            [class.spinner]="loadingLoad"
            [disabled]="loadingLoad || loadingLastDays"
            (click)="getLogs()"
          >
            Load
          </button>
        </form>
      </mat-card>
    </div>
    <button
      mat-raised-button
      color="warn"
      [class.spinner]="loadingLastDays"
      [disabled]="loadingLastDays || loadingLoad"
      (click)="getLastDaysModulesErrors()"
      style="margin: 0 0 0 10px"
    >
      Last 5 days modules errors
    </button>
  </div>

  <div style="margin: 30px 0 0 20px; width: 90%">
    <mat-accordion *ngIf="isShownLoad">
      <mat-expansion-panel
        *ngFor="let log of logs"
        [expanded]="false"
        [disabled]="!log.hasValues"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span
              *ngIf="log?.values?.length > 1; else elseBlockDatesOneDate"
              class="logmodule"
            >
              <label class="text-primary">{{ log.labelModule }}</label></span
            >
            <ng-template #elseBlockDatesOneDate>
              <span class="logmodule"
                ><label class="text-primary">{{ log.labelModule }}</label></span
              >
              <span class="logdate"
                ><label class="text-secondary">{{
                  log.values[0].labelDate
                }}</label></span
              >
            </ng-template>
          </mat-panel-title>
          <mat-panel-description *ngIf="!log.hasValues"
            ><label class="text-danger">No data</label></mat-panel-description
          >
          <mat-panel-description *ngIf="log.hasValues"></mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div *ngFor="let logByDates of log.values">
            <app-logger-date
              [logDates]="logByDates"
              [nbDates]="log.values.length"
            ></app-logger-date>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion *ngIf="isShownLastDays">
      <mat-expansion-panel
        *ngFor="let logLastDays of logsLastDays"
        [expanded]="false"
        [disabled]="!logLastDays.hasValues"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="logmodule"
              ><label class="text-primary">{{
                logLastDays.labelModule
              }}</label></span
            >
          </mat-panel-title>
          <mat-panel-description *ngIf="!logLastDays.hasValues"
            ><label class="text-danger">No errors</label></mat-panel-description
          >
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent *ngIf="logLastDays.hasValues">
          <mat-grid-list cols="7" rowHeight="2:1">
            <mat-grid-tile *ngFor="let logByDates of logLastDays.values">
              <div class="w-50">
                <button
                  mat-raised-button
                  color="white"
                  style="margin: 0 0 0 10px"
                  disabled
                  *ngIf="logByDates?.values?.length == 0; else elseBlockDates"
                >
                  {{ logByDates.labelDate }}
                </button>
                <ng-template #elseBlockDates>
                  <button
                    mat-stroked-button
                    color="warn"
                    (click)="
                      getErrors(logLastDays.labelModule, logByDates.labelDate)
                    "
                    style="margin: 0 0 0 10px"
                  >
                    {{ logByDates.labelDate }}
                  </button>
                </ng-template>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
          <div *ngFor="let logByDates of logLastDays.values">
            <div
              *ngFor="let logByTypes of logByDates.values"
              [hidden]="true"
              [id]="logLastDays.labelModule + '-' + logByDates.labelDate"
              #logErrors
            >
              <ngx-json-viewer
                [json]="logByTypes.values"
                [expanded]="true"
                [depth]="1"
              ></ngx-json-viewer>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
